import * as React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error: error };
    }

    render() {
        if (this.state.hasError) {
            if(this.props.env === "production") {
                return <div id="PageWrapper">{`An internal error has occured.`}</div>;
            } else {
                return <div id="PageWrapper">{`${this.state.error}`}</div>;
            }
        }

        return this.props.children;
    }
}

export default ErrorBoundary
